import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import DataChip from '../documentation/chip/DataChip';
import TagModal from '../documentation/modal/TagModal';
import TriggerModal from '../documentation/modal/TriggerModal';
import VariableModal from '../documentation/modal/VariableModal';

import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

import { useOvermind } from '../../overmind';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  description:{
    color: theme.palette.error.light,
    fontSize: theme.typography.pxToRem(15),
  }
}));

const Modal = (props) =>{
  const { state } = useOvermind();
  const { chipClick, modalClose} = props;


  if(typeof state.recommendation.modal !== 'undefined'){
    if (state.recommendation.modal.display && state.recommendation.modal.type === 'tag'){

        return <TagModal data={state.recommendation.modal.data} type={state.recommendation.modal.type} chipClick={chipClick} modalState={state.recommendation.modal.display} modalClose={modalClose}/>;
    }
    if (state.recommendation.modal.display && state.recommendation.modal.type=== 'trigger'){
        return <TriggerModal data={state.recommendation.modal.data} type={state.recommendation.modal.type} chipClick={chipClick} modalState={state.recommendation.modal.display} modalClose={modalClose}/>
    }
    if (state.recommendation.modal.display && state.recommendation.modal.type === 'variable'){
        return <VariableModal data={state.recommendation.modal.data} type={state.recommendation.modal.type} chipClick={chipClick} modalState={state.recommendation.modal.display} modalClose={modalClose}/>;
    }
  }else{
    return(<div></div>);
  }
}


function ChipList(props) {
  const { items, tagType, listType, chipClick } = props;
  let itemList = [];

  // Reformats Container Values into Data Chip Values
  if(items.length > 0){
    if(listType === 'container' && tagType ==='tag'){
      itemList = items.map(value=>({"name":value.name,"type":value.type,"id":value.tagId}));
    } else if(listType === 'container' && tagType ==='trigger'){
      itemList = items.map(value=>({"name":value.name,"type":value.type,"id":value.triggerId}));
    } else if(listType === 'container' && tagType ==='variable'){
      itemList = items.map(value=>({"name":value.name,"type":value.type,"id":value.variableId}));
    }else{
      itemList = items;
    }
  }

  const renderTag = () =>{
    if(itemList.length >= 0){
      return itemList.map((val, key)=>{
        return <DataChip key={key} value={val} chipClick={chipClick} tagType={tagType}/>
      });
    }else{
      return (<div></div>);
    }
  }

  return (
    <div>{renderTag()}</div>
  );
}

ChipList.propTypes = {
  items: PropTypes.array.isRequired,
};

function AccordianItem(props) {
  const classes = useStyles();
  const { list, expandState, expandHandler, chipClick} = props;

  if(list.title.includes('0') === false){

    return(
      <Accordion expanded={expandState=== list.id} onChange={expandHandler(list.id)}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography className={classes.heading}>{list.category}</Typography>
          <Typography className={classes.secondaryHeading}>{list.title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Container maxWidth="lg" className={classes.container}>
            <Grid item xs={12} md={12} lg={12} >
              <Box pb={2}>
                <Typography className={classes.description}>{list.description}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <ChipList items={list.list} tagType={list.tagType} listType={list.listType} chipClick={chipClick} />
            </Grid>
          </Container>
        </AccordionDetails>
      </Accordion>
    )
  }else{
    return null;
  }
}

export default function RecommendationList() {
  const classes = useStyles();
  const { state, actions } = useOvermind();
  const [expanded, setExpanded] = React.useState(false);

  const chipClick = (data, type) => {
    let modalData = {};

    if(typeof window.__GTM_DOCS__.container[type] !== 'undefined'){
      window.__GTM_DOCS__.container[type].forEach((tag)=>{
        if(tag.name === data.name){
          modalData = tag;
        }
      });
    }
    actions.setModalData({"display":true,"type":type,"data":modalData});
  };

  const modalClose = () =>{
    actions.closeModal();
  }

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return(
    <div className={classes.root}>
      <Modal chipClick={chipClick} modalClose={modalClose}/>
      {state.recommendation.reco.map(reco => <AccordianItem key={reco.id} list={reco} chipClick={chipClick} expandState={expanded} expandHandler={handleChange}/>)}
    </div>
  );
}
